import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { changeUrlGivenCurrentQueryParams } from 'components/LinkWithQuery';
import { currentOpenModalStates, layouts } from 'config/constants';

import { connect } from 'react-redux';

import { Button } from 'components/v3';

import { sx } from '../../input/EmptyInputSuggestions/EmptyInputSuggestions.styles';

import withEmbedded from 'root/hocs/withEmbedded';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SvgIcon from '@mui/material/SvgIcon';
import ChatIcon from 'svg/chat.svg';
import { KnowledgeGraphIcon } from 'components/Icons';

export const CloseButton = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Button
      layout={layouts.veezoo}
      classes={{ root: { fontWeight: 500 } }}
      noBorders
      icon={<CloseRoundedIcon sx={sx.buttonIcon} />}
      onClick={() => {
        changeUrlGivenCurrentQueryParams(history, {
          showDialog: null
        });
      }}
    >
      {t('close')}
    </Button>
  );
};

export const DiscoveryButton = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Button
      layout={layouts.veezoo}
      classes={{ root: { fontWeight: 500 } }}
      noBorders
      icon={<SvgIcon component={ChatIcon} viewBox="1 -2 24 24" sx={sx.buttonIcon} />}
      onClick={() => {
        changeUrlGivenCurrentQueryParams(history, {
          showDialog: currentOpenModalStates.discovery
        });
      }}
    >
      {t('welcome-message.what-can-i-ask')}
    </Button>
  );
};

const mapStateToProps = state => ({
  hasKnowledgeGraphSupport: state.knowledgeGraphMeta.meta.hasKnowledgeGraphSupport
});

const KgButtonNotConnected = props => {
  const { hasKnowledgeGraphSupport, isEmbedded, onClickAway } = props;
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Button
      layout={layouts.veezoo}
      classes={{ root: { fontWeight: 500, visibility: hasKnowledgeGraphSupport ? 'visible' : 'hidden' } }}
      noBorders
      icon={<KnowledgeGraphIcon sx={sx.buttonIcon} />}
      onClick={() => {
        if (isEmbedded) {
          changeUrlGivenCurrentQueryParams(history, {
            showDialog: currentOpenModalStates.knowledgeGraph
          });
        } else {
          changeUrlGivenCurrentQueryParams(history, {
            kgSidebar: true,
            visualMode: true,
            showDialog: null
          });
          onClickAway(null);
        }
      }}
    >
      {t('welcome-message.what-data-is-there')}
    </Button>
  );
};

export const KgButton = connect(mapStateToProps)(withEmbedded(KgButtonNotConnected));
